import axios from "axios"
import { BASE_URL } from "../constants/api-end-pionts"

const getApiServices = async (url:string)=>{

    const Authorization = `Bearer ${localStorage.getItem("token")}`;

    const api = axios.create({
        baseURL: BASE_URL,
        headers:{
            "Content-Type":"application/json",
            "Authorization":Authorization
        },
    });
    
    try{

        let response = await api.get(url);
        return response.data;
        
    }catch(err){
        console.log("error:",err);
        throw err;
    }

}

export default getApiServices;